import { usePersona } from "@/lib/persona";
import { AttendeeShell } from "./AttendeeShell";
import { PartnerShell } from "./PartnerShell";
import { OrganizerShell } from "./OrganizerShell";

/**
 * Renders the persona-appropriate authenticated shell.
 * Used by the `/app` layout route after the auth gate clears.
 */
export function PersonaShell() {
  const persona = usePersona();
  switch (persona.role) {
    case "attendee":
      return <AttendeeShell />;
    case "partner":
      return <PartnerShell />;
    case "organizer":
      return <OrganizerShell />;
  }
}
